import { atarrayaApi } from '../../api-common'

export const state = {
  // feedProducers: [],
  // simpleFeedProducers: [],
  // feedBrands: [],
  // simpleFeedBrands: [],
  // feeds: [],
  // feedcharacteristics: [],
  // SimpleFeedcharacteristics: [],
  strategies: [],
  simpleStrategies: [],
  strategyStage: [],
  scheduler: [],
  feedItems: []
}

export const getters = {
  // feedProducers: (state) => state.feedProducers,
  // simpleFeedProducers: (state) => state.simpleFeedProducers,
  // feedBrands: (state) => state.feedBrands,
  // simpleFeedBrands: (state) => state.simpleFeedBrands,
  // feeds: (state) => state.feeds,
  // feedcharacteristics: (state) => state.feedcharacteristics,
  // SimpleFeedcharacteristics: (state) => state.SimpleFeedcharacteristics,
  strategies: (state) => state.strategies,
  simpleStrategies: (state) => state.simpleStrategies,
  strategyStage: (state) => state.strategyStage,
  scheduler: (state) => state.scheduler,
  feedItems: (state) => state.feedItems
}

export const mutations = {
  // LOAD_FEED_PRODUCERS(state, data) {
  //   state.feedProducers = data
  // },

  // LOAD_SIMPLE_FEED_PRODUCERS(state, data) {
  //   state.simpleFeedProducers = data
  // },

  // ADD_FEED_PRODUCER(state, data) {
  //   state.feedProducers.push(data)
  // },

  // UPDATE_FEED_PRODUCER(state, data) {
  //   const index = state.feedProducers.findIndex((f) => f.id === data.id)
  //   if (index >= 0) {
  //     for (const attr in data) {
  //       if (Object.hasOwnProperty.call(state.feedProducers[index], attr)) {
  //         state.feedProducers[index][attr] = data[attr]
  //       }
  //     }
  //   }
  // },

  // DELETE_FEED_PRODUCER(state, item) {
  //   state.feedProducers.splice(state.feedProducers.indexOf(item), 1)
  // },

  // LOAD_FEED_BRANDS(state, data) {
  //   state.feedBrands = data
  // },

  // LOAD_SIMPLE_FEED_BRANDS(state, data) {
  //   state.simpleFeedBrands = data
  // },

  // ADD_FEED_BRAND(state, data) {
  //   const brand = { ...data, producer: { id: data.producer_id } }
  //   state.feedBrands.push(brand)
  // },

  // UPDATE_FEED_BRAND(state, data) {
  //   const index = state.feedBrands.findIndex((f) => f.id === data.id)
  //   if (index >= 0) {
  //     for (const attr in data) {
  //       if (Object.hasOwnProperty.call(state.feedBrands[index], attr)) {
  //         state.feedBrands[index][attr] = data[attr]
  //       }
  //     }
  //   }
  // },

  // DELETE_FEED_BRAND(state, item) {
  //   state.feedBrands.splice(state.feedBrands.indexOf(item), 1)
  // },

  // LOAD_FEEDS(state, data) {
  //   state.feeds = data
  // },

  // ADD_FEED(state, data) {
  //   const feed = {
  //     ...data,
  //     brand: { id: data.brand_id },
  //     characteristics: { id: data.characteristics_id }
  //   }
  //   state.feeds.push(feed)
  // },

  // DELETE_FEED(state, item) {
  //   state.feeds.splice(state.feeds.indexOf(item), 1)
  // },

  // LOAD_CHARACTERISTICS(state, data) {
  //   state.feedcharacteristics = data
  // },

  // LOAD_SIMPLE_CHARACTERISTICS(state, data) {
  //   state.SimpleFeedcharacteristics = data
  // },

  // ADD_CHARACTERISTICS(state, data) {
  //   const characteristics = data
  //   state.feedcharacteristics.push(characteristics)
  // },

  LOAD_STRATEGIES(state, data) {
    state.strategies = data
  },

  LOAD_SIMPLE_STRATEGIES(state, data) {
    state.simpleStrategies = data
  },

  ADD_STRATEGY(state, data) {
    const strategy = data
    state.strategies.push(strategy)
  },

  UPDATE_STRATEGY(state, data) {
    const index = state.strategies.findIndex((f) => f.id === data.id)
    if (index >= 0) {
      for (const attr in data) {
        if (Object.hasOwnProperty.call(state.strategies[index], attr)) {
          state.strategies[index][attr] = data[attr]
        }
      }
    }
  },

  DELETE_STRATEGY(state, item) {
    state.strategies.splice(state.strategies.indexOf(item), 1)
  },

  LOAD_STRATEGY_STAGE(state, data) {
    state.strategyStage = data
  },

  ADD_STRATEGY_STAGE(state, data) {
    const strategyStage = data
    state.strategyStage.push(strategyStage)
  },

  DELETE_STRATEGY_STAGE(state, item) {
    state.strategyStage.splice(state.strategyStage.indexOf(item), 1)
  },

  ADD_STRATEGY_STAGE_FILE(state, data) {
    const strategyStage = data
    state.strategyStage.push(strategyStage)
  },

  LOAD_STRATEGIES_SCHEDULE(state, data) {
    state.scheduler = data
  },

  ADD_STRATEGIES_SCHEDULE(state, data) {
    const scheduler = data
    state.scheduler.push(scheduler)
  },

  LOAD_FEED_ITEMS(state, data) {
    state.feedItems = data
  }
}

export const actions = {
  // async getFeedProducers({ commit }) {
  //   const response = await atarrayaApi.get('feeding/producers?with=brands')
  //   commit('LOAD_FEED_PRODUCERS', response.data.data)
  //   return response.data.data
  // },

  // async getSimpleFeedProducers({ commit }) {
  //   const response = await atarrayaApi.get('feeding/producers')
  //   commit('LOAD_SIMPLE_FEED_PRODUCERS', response.data.data)
  //   return response.data.data
  // },

  // async addFeedProducer({ commit }, data) {
  //   const response = await atarrayaApi.post('/feeding/producers', data)
  //   commit('ADD_FEED_PRODUCER', response.data.data)
  // },

  // async editFeedProducer({ commit }, data) {
  //   await atarrayaApi.patch(`/feeding/producers/${data.id}`, data)
  //   commit('UPDATE_FEED_PRODUCER', data)
  // },

  // async deleteFeedProducer({ commit }, item) {
  //   await atarrayaApi.delete(`/feeding/producers/${item.id}`)
  //   commit('DELETE_FEED_PRODUCER', item)
  // },

  // async getFeedBrans({ commit }) {
  //   const response = await atarrayaApi.get(
  //     '/feeding/producers/brands?with=producer'
  //   )
  //   commit('LOAD_FEED_BRANDS', response.data.data)
  //   return response.data.data
  // },

  // async getSimpleFeedBrans({ commit }) {
  //   const response = await atarrayaApi.get('/feeding/producers/brands')
  //   commit('LOAD_SIMPLE_FEED_BRANDS', response.data.data)
  //   return response.data.data
  // },

  // async addFeedBrand({ commit }, data) {
  //   const response = await atarrayaApi.post(
  //     `/feeding/producers/${data.producer_id}/brands`,
  //     data
  //   )
  //   commit('ADD_FEED_BRAND', response.data.data)
  // },

  // async editFeedBrans({ commit }, data) {
  //   await atarrayaApi.patch(
  //     `/feeding/producers/${data.producer_id}/brands/${data.id}`,
  //     data
  //   )
  //   commit('UPDATE_FEED_BRAND', data)
  // },

  // async deleteFeedBrand({ commit }, item) {
  //   await atarrayaApi.delete(
  //     `/feeding/producers/${item.producer_id}/brands/${item.id}`
  //   )
  //   commit('DELETE_FEED_BRAND', item)
  // },

  // async getFeeds({ commit }) {
  //   const response = await atarrayaApi.get(
  //     '/feed?with=characteristics&with=brand'
  //   )
  //   commit('LOAD_FEEDS', response.data.data)
  //   return response.data.data
  // },

  // async addFeed({ commit }, data) {
  //   const response = await atarrayaApi.post('/feed', data)
  //   commit('ADD_FEED', response.data.data)
  // },

  // async deleteFeed({ commit }, item) {
  //   await atarrayaApi.delete(`/feed/${item.id}`)
  //   commit('DELETE_FEED', item)
  // },

  // async getCharacteristics({ commit }) {
  //   const response = await atarrayaApi.get('/feeding/characteristics')
  //   commit('LOAD_CHARACTERISTICS', response.data.data)
  //   return response.data.data
  // },

  // async getSimpleCharacteristics({ commit }) {
  //   const response = await atarrayaApi.get('/feeding/characteristics')
  //   commit('LOAD_SIMPLE_CHARACTERISTICS', response.data.data)
  //   return response.data.data
  // },

  // async addCharacteristic({ commit }, data) {
  //   const response = await atarrayaApi.post('/feeding/characteristics', data)
  //   commit('ADD_CHARACTERISTICS', response.data.data)
  //   return response.data.data
  // },

  async getStrategies({ commit }) {
    const response = await atarrayaApi.get('/feeding/strategy')
    commit('LOAD_STRATEGIES', response.data.data)
    return response.data.data
  },

  async getSimpleStrategies({ commit }) {
    const response = await atarrayaApi.get('/feeding/strategy')
    commit('LOAD_SIMPLE_STRATEGIES', response.data.data)
    return response.data.data
  },

  async addStrategy({ commit }, data) {
    const response = await atarrayaApi.post('/feeding/strategy', data)
    commit('ADD_STRATEGY', response.data.data)
  },

  async editStrategy({ commit }, data) {
    await atarrayaApi.patch(`/feeding/strategy/${data.id}`, data)
    commit('UPDATE_STRATEGY', data)
  },

  async deleteStrategy({ commit }, data) {
    await atarrayaApi.delete(`/feeding/strategy/${data.id}`)
    commit('DELETE_STRATEGY', data)
  },

  async getStrategyStage({ commit }, strategy) {
    const response = await atarrayaApi.get(`/feeding/strategy-stage`, {
      params: {
        strategyId: strategy
      }
    })
    commit('LOAD_STRATEGY_STAGE', response.data.data)
    return response.data.data
  },

  async addStrategyStage({ commit }, data) {
    const response = await atarrayaApi.post(`/feeding/strategy-stage`, data)
    commit('ADD_STRATEGY_STAGE', response.data.data)
  },

  async deleteStrategyStage({ commit }, data) {
    await atarrayaApi.delete(`/feeding/strategy-stage/${data.stage.id}`)
    commit('DELETE_STRATEGY_STAGE', data.stage)
  },

  async addStrategyStageFile({ commit }, data) {
    const response = await atarrayaApi.post(
      `/feeding/strategy-scheduling/excel/strategy/${data.strategyId}/farm/${data.farmId}`,
      data.file,
      {
        'Content-Type': 'multipart/form-data'
      }
    )
    commit('ADD_STRATEGY_STAGE_FILE', response.data.data)
    return response.data.data
  },

  async getStrategyStageSchedule({ commit }, data) {
    const response = await atarrayaApi.get(`/feeding/strategy-scheduling`, {
      params: {
        farmId: data.farmId,
        strategyStageId: data.strategyStageId
      }
    })
    commit('LOAD_STRATEGIES_SCHEDULE', response.data.data)
    return response.data.data
  },

  async getStrategyStageScheduleFull({ commit }, data) {
    const response = await atarrayaApi.get(
      `/feeding/strategy-scheduling/stage/${data.strategyStageId}/farm/${data.farmId}`
    )
    commit('LOAD_STRATEGIES_SCHEDULE', response.data.data)
    return response.data.data
  },

  async addStrategyStageSchedule({ commit }, data) {
    const response = await atarrayaApi.post(
      `/feeding/strategy-scheduling`,
      data
    )
    commit('ADD_STRATEGIES_SCHEDULE', response.data.data)
  },

  async getFeedItems({ commit }, data) {
    const response = await atarrayaApi.get(`/feeding/inventory-item`, {
      params: {
        farmId: data.farmId
      }
    })
    commit('LOAD_FEED_ITEMS', response.data.data)
    return response.data.data
  }
}
